<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i class="fa fa-bars mr-1"></i>
                        <span>Slide Group</span>
                    </b-col>
                </b-row>
            </b-card-header>
            <t-slidegroup />
        </b-card>
    </div>
</template>
  
<script>
export default {
    name: "SlideGroup",
    data() {
        return {
            busy: false,
        };
    },

};
</script>
  